import { SkeletonArea } from 'components/skeletonArea';
import { Wrapper } from 'components/wrapper';
import { selectInfoTemplateAvvenimento } from 'features/sport';
import { SportMarcatoriCarousel } from 'features/sport/components/sportMarcatoriCarousel';
import { DynamicSportTableScommesse as SportMarcatoriTable } from 'features/sport/components/sportMarcatoriTableScommesse';
import { useAvvenimenti } from 'features/sport/hooks';
import { setAvvenimentoSelected } from 'features/sport/marcatoriSlice';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect } from 'react';
import { SportsTipoScommessa } from 'types/swagger';
import { isTruthy } from 'utility/functions';
import marcatoriStyles from '../marcatori/PageContent.module.scss';

type AvvenimentoMarcatoreTableProps = {
  tipoScommessa: SportsTipoScommessa;
};

export const AvvenimentoMarcatoriTable = ({
  tipoScommessa: { infoTipoScommessaKeyStringList },
}: AvvenimentoMarcatoreTableProps) => {
  const avvenimentoList = useAvvenimenti();
  const dispatch = useAppDispatch();
  const { scommessaStatus } = useTypedSelector(selectInfoTemplateAvvenimento);

  useEffect(() => {
    if (isTruthy(avvenimentoList?.length)) {
      dispatch(
        setAvvenimentoSelected({
          avvenimentoKey: avvenimentoList[0].key ?? '',
          competitor: 1,
        })
      );
    }
  }, [avvenimentoList, dispatch]);

  return (
    <Wrapper noPaddingBottom noPaddingLeft noPaddingRight noPaddingTop>
      <SportMarcatoriCarousel
        hasVerticalMargin
        avvenimentoKeys={avvenimentoList.map((avvenimento) => avvenimento.key!)}
      />

      {scommessaStatus === 'loading' ? (
        new Array(10)
          .fill(0)
          .map((_, index) => (
            <SkeletonArea key={index} delay={index} className={marcatoriStyles.skeletonAvvenimentoRow} />
          ))
      ) : (
        <SportMarcatoriTable infoTipoScommessaKeyList={infoTipoScommessaKeyStringList ?? []} />
      )}
    </Wrapper>
  );
};
